import { render, staticRenderFns } from "./AtualizarRamais.vue?vue&type=template&id=df377e1e&"
import script from "./AtualizarRamais.vue?vue&type=script&lang=js&"
export * from "./AtualizarRamais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports